import { LegalStuffPageContent } from '@/components/legalStuff/LegalStuffPageContent';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/faq';
import { Box } from '@lemonade-hq/cdk';
import { DocumentTypes } from 'contentlayer/generated';
import type React from 'react';
import style from 'styled-components';

const ContentWrapper = style(Box)`
  position: relative;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

interface LegalStuffPageTemplateProps {
  config: Config;
}

export const LegalStuffPageTemplate: React.FC<LegalStuffPageTemplateProps> = ({ config }) => {
  useShowHeaderCtaOnScroll(true);
  return (
    <>
      <SEO {...config.seo} />
      <Layout pt={[40, 70]} headerActions={config.layout.headerActions}>
        <ContentWrapper px="20px" pb="40px">
          <LegalStuffPageContent content={config.MDXContent as DocumentTypes} />
        </ContentWrapper>
      </Layout>
    </>
  );
};
